/**
 * Makes links to a Scroll anchor section move smoothly without navigating away
 * from the current page. Existing Shopify URL settings can use #anchor-id.
 */
(() => {
  const getTargetFromHash = (hash) => {
    if (!hash || hash === '#') return null;

    let id;
    try {
      id = decodeURIComponent(hash.slice(1));
    } catch (error) {
      return null;
    }

    const target = document.getElementById(id);
    return target?.hasAttribute('data-scroll-anchor') ? target : null;
  };

  const getHeaderOffset = () => {
    return Array.from(document.querySelectorAll('.announcement-bar-section, .header-section'))
      .filter((element) => {
        const position = window.getComputedStyle(element).position;
        const bounds = element.getBoundingClientRect();

        return (position === 'fixed' || position === 'sticky') && bounds.bottom > 0;
      })
      .reduce((offset, element) => offset + element.getBoundingClientRect().height, 0);
  };

  const scrollToTarget = (target, behavior = 'smooth') => {
    const top = window.scrollY + target.getBoundingClientRect().top - getHeaderOffset() - 24;
    const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

    window.scrollTo({
      top: Math.max(0, top),
      behavior: reducedMotion ? 'auto' : behavior
    });
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || url.search !== window.location.search) return;

    const target = getTargetFromHash(url.hash);
    if (!target) return;

    event.preventDefault();
    history.pushState(null, '', url.hash);
    scrollToTarget(target);
  });

  window.addEventListener('hashchange', () => {
    const target = getTargetFromHash(window.location.hash);
    if (target) scrollToTarget(target);
  });

  const initialTarget = getTargetFromHash(window.location.hash);
  if (initialTarget) requestAnimationFrame(() => scrollToTarget(initialTarget, 'auto'));
})();
